import { defineMessages } from "react-intl";

export const messages = defineMessages({
    statementsIntro: {
        id: "pages.report.intro",
        defaultMessage: "Locate and download your monthly statements.",
    },
    statementsInfo: {
        id: "pages.report.info",
        defaultMessage: `Since January 2024, Modulor only retains records for two years plus the current year.<br></br>
Statements are available from 2023 only.`,
    },
    menuFinancial: {
        id: "reports.menu.financial",
        defaultMessage: "Financial",
    },
    customReportsIntro: {
        id: "reports.custom_reports.intro",
        defaultMessage: "Generate and download custom financial reports",
    },
    customReportsGenerateButton: {
        id: "reports.custom_reports.generate-button",
        defaultMessage: "Generate a new report",
    },
    customReportsInfo: {
        id: "reports.custom_reports.info",
        defaultMessage: `Only one custom report can be generated at a time using the "Create Report" form.<br></br>
You can generate a summary report with the total for each platform or a detailed report for all platforms over
the chosen period.<br></br>
Reports can be generated for a period of up to two years plus the current year.`,
    },
    customReportsInProgressError: {
        id: "reports.custom_reports.in_progress_error",
        defaultMessage: "You may only generate one report at once.",
    },
    statementSingular: {
        id: "reports.statement_singular",
        defaultMessage: "Statement",
    },
    statementPlural: {
        id: "reports.statementPlural",
        defaultMessage: "Statements",
    },
    reportSingular: {
        id: "reports.report.entity_singular",
        defaultMessage: "Report",
    },
    reportPlural: {
        id: "reports.report.entity_plural",
        defaultMessage: "Reports",
    },
    reportColumnPeriod: {
        id: "reports.report.columns.period",
        defaultMessage: "Period",
    },
    reportColumnDescription: {
        id: "reports.report.columns.description",
        defaultMessage: "Description",
    },
    reportColumnStatus: {
        id: "reports.report.columns.status",
        defaultMessage: "Status",
    },
    reportColumnType: {
        id: "reports.report.columns.type",
        defaultMessage: "Type",
    },
    reportColumnGeneratedBy: {
        id: "reports.report.columns.generated_by",
        defaultMessage: "Generated By",
    },
    reportColumnCreatedAt: {
        id: "reports.report.columns.created_at",
        defaultMessage: "Created",
    },
    reportColumnUpdatedAt: {
        id: "reports.report.columns.updated_at",
        defaultMessage: "Updated",
    },
    month: {
        id: "reports.table.month",
        defaultMessage: "Month",
    },
    lastUpdated: {
        id: "reports.table.last_updated",
        defaultMessage: "Last updated",
    },
    numberRows: {
        id: "reports.table.number_rows",
        defaultMessage: "Number of rows",
    },
    amountPayable: {
        id: "reports.table.amount_payable",
        defaultMessage: "Amount payable",
    },
    download: {
        id: "reports.table.download",
        defaultMessage: "Download",
    },
    loadMoreReports: {
        id: "reports.general.load-more-reports",
        defaultMessage: "Load more reports",
    },
    loadMoreStatements: {
        id: "reports.general.load-more-statements",
        defaultMessage: "Load more statements",
    },
});
